import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCandidateConstraintIconminBounded = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	color: "gray",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		height: "100%",
		width: "100%",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("g", {
		stroke: "black",
		strokeDasharray: "5 4 6 4 5",
		strokeWidth: 4,
		children: /* @__PURE__ */ _jsx("line", {
			x1: 2,
			x2: 2,
			y1: 0,
			y2: 24
		})
	})]
});
export default SvgCandidateConstraintIconminBounded;
